import React from 'react';
import { CreditCard, FileText, Users } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { companyInfo } from '../mock';
import { Card, CardContent } from './ui/card';
import { Link } from 'react-router-dom';

const QuickActions = () => {
  const { language } = useLanguage();

  const actions = {
    en: [
      {
        icon: CreditCard,
        title: 'Make A Payment',
        description: 'Managing your insurance as simple and convenient as possible.',
        link: '/payment'
      },
      {
        icon: FileText,
        title: 'Get a Quote',
        description: 'A Legacy of Protection, Powered by Community',
        link: '/quote/auto',
        external: false
      },
      {
        icon: Users,
        title: 'Happy Customers',
        description: 'Real People. Real Coverage. Real Smiles.',
        link: '/customers'
      }
    ],
    es: [
      {
        icon: CreditCard,
        title: 'Hacer un Pago',
        description: 'Gestionar su seguro de manera simple y conveniente.',
        link: '/payment'
      },
      {
        icon: FileText,
        title: 'Obtener Cotización',
        description: 'Un Legado de Protección, Impulsado por la Comunidad',
        link: '/quote/auto',
        external: false
      },
      {
        icon: Users,
        title: 'Clientes Felices',
        description: 'Personas Reales. Cobertura Real. Sonrisas Reales.',
        link: '/customers'
      }
    ]
  };

  return (
    <section className="py-12 -mt-16 relative z-20">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-6">
          {actions[language].map((action, index) => {
            const Icon = action.icon;
            
            const cardContent = (
              <CardContent className="p-8 text-center space-y-4">
                <div className="w-16 h-16 mx-auto bg-gradient-to-br from-blue-100 to-blue-50 rounded-full flex items-center justify-center group-hover:from-blue-600 group-hover:to-blue-700 transition-all duration-300">
                  <Icon className="w-8 h-8 text-blue-700 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-700 transition-colors">
                  {action.title}
                </h3>
                <p className="text-gray-600">{action.description}</p>
                <button className="text-blue-700 font-semibold group-hover:gap-2 inline-flex items-center gap-1 transition-all">
                  {language === 'en' ? 'Learn More' : 'Más Información'}
                  <span className="group-hover:translate-x-1 transition-transform">→</span>
                </button>
              </CardContent>
            );
            
            return (
              <Card
                key={index}
                className="group hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-2 bg-white border-none"
              >
                {action.external ? (
                  <a 
                    href={action.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block"
                  >
                    {cardContent}
                  </a>
                ) : (
                  <Link to={action.link} className="block">
                    {cardContent}
                  </Link>
                )}
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default QuickActions;